import { Autocomplete, TextField } from "@mui/material"
import { useState, useEffect } from "react"
import { API } from "../../services/API/API";
import { txt } from "../../services/translation";

export default function CourseSelect({value, onChange, required, disabled, sx}){

    const [courses, setCourses] = useState([]);
    const [titleValue, setTitleValue] = useState(null)

    useEffect(() => {
        API.getCourses()
            .then(r => {
                const items = Array.isArray(r.data) ? r.data : [];
                setCourses(items);
                return setTitleValue(items.find(i => i.id === value)?.title || null);
            })
            .catch(e => console.log(e))
    }, [value])

    const handleChange = (tv) => {
        setTitleValue(tv);
        let course = courses.find(c => c.title === tv);
        return onChange(course ? course.id : null)
    }

    const courseTitles = () => {
        let titles = [];
        courses.map(c => {
            if(titles.indexOf(c.title) < 0) titles.push(c.title);
            return false;
        })
        return titles;
    }

    return <Autocomplete
        options={courseTitles()}
        renderInput={params => <TextField 
            {...params}
            label={txt('course')}
            size='small'
            required={required}
        />}
        value={titleValue}
        onChange={(e, v) => handleChange(v)}
        disabled={disabled ? true : false}
        sx={sx || {}}
    />
}